import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { useMemo } from 'react';

interface Props {
  value: number;
  min: number;
  max: number;
}

export function UI_PRIMITIVE__slider_thumb_static({ value, min, max }: Props) {
  /*
   * STATE
   */

  const percent = useMemo(() => new DTO__number_range(min, max).value_to_percentage(value), [value, min, max]);

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  return (
    <div
      style={{ left: `calc(${percent}%)` }}
      className={`          ui-primitive-slider-thumb-static
                            absolute
                            translate-x-[-50%]
                            flex-center
                            min-w-8 min-h-4
                            text-xs text-component-item-foreground
                            transition duration-200 hover-animation
                            border border-component-item-border border-dashed
                            bg-bar rounded-lg
                            opacity-75
                            disabled:pointer-events-none disabled:opacity-50
                            focus-visible:outline-none
                          `}
    >
      {value}
    </div>
  );
}
